import type {
  RequestPasswordResetCommand,
  RequestPasswordResetResult,
  ResetPasswordCommand,
  ResetPasswordResult,
} from "@/domain/model/PasswordReset";
import type { PasswordResetService } from "@/domain/port/PasswordResetService";
import type { HttpClient } from "@/infrastructure/HttpClient";
import type {
  PasswordResetInitResponseDto,
  PasswordResetResponseDto,
} from "./dto/PasswordResetDto";
import {
  mapPasswordResetInitResponseDtoToModel,
  mapPasswordResetResponseDtoToModel,
  mapRequestPasswordResetCommandToDto,
  mapResetPasswordCommandToDto,
} from "./mappers/PasswordResetMapper";

export class PasswordResetServiceImpl implements PasswordResetService {
  constructor(private readonly http: HttpClient) {}

  async requestPasswordReset(
    cmd: RequestPasswordResetCommand,
    signal?: AbortSignal,
  ): Promise<RequestPasswordResetResult> {
    const body = mapRequestPasswordResetCommandToDto(cmd);

    const dto = await this.http.request<PasswordResetInitResponseDto>(
      "/api/password/reset/init",
      {
        method: "POST",
        body: JSON.stringify(body),
        signal,
      },
      "none"
    );

    return mapPasswordResetInitResponseDtoToModel(dto);
  }

  async resetPassword(
    cmd: ResetPasswordCommand,
    signal?: AbortSignal,
  ): Promise<ResetPasswordResult> {
    const body = mapResetPasswordCommandToDto(cmd);

    const dto = await this.http.request<PasswordResetResponseDto>(
      "/api/password/reset",
      {
        method: "POST",
        body: JSON.stringify(body),
        signal,
      },
      "none"
    );

    return mapPasswordResetResponseDtoToModel(dto);
  }
}
